// 套餐购买
<template>
  <div class="tcgm width1394 d-flex d-flex-jc-c d-flex-fw-w">
    <div class="item" v-for="(item, index) in tcgmList" :key="index">
      <p class="title">
        {{ item.title }}
        <span>({{ item.price }}元/个/月)</span>
      </p>
      <p class="price">
        <b>¥</b>
        {{ item.amount }}
      </p>
      <div class="count d-flex">
        <span>并发数(个):</span>
        <dl>
          <dd
            class="d-flex d-flex-aic"
            v-for="(che, cheIndex) in item.checkList"
            :key="cheIndex"
            @change="checkChange(index, cheIndex)"
          >
<!--            <input
              type="radio"
              :name="item.checkName"
              :id="`${item.checkName}_${cheIndex}`"
            />-->
            <label :for="`${item.checkName}_${cheIndex}`">{{ che }}</label>
          </dd>
        </dl>
      </div>
      <div class="count d-flex">
        <span>购买数量：</span>
        <span class="input d-flex">
          <i class="del" @click="inputChange(index, 'del')"></i>
          <input
            type="text"
            :value="item.count"
            @input="countChange($event, index)"
          />
          <i class="add" @click="inputChange(index, 'add')"></i>
        </span>
      </div>
      <p class="text1">时效：15分钟以上至24小时</p>
      <p class="text1">覆盖地区：全国</p>
      <p class="text1">质量度：优质</p>
      <p class="text1">支持类型：HTTP,SOCK5</p>
      <a :href="item.link">购买</a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tcgmList: [
        {
          title: "套餐1",
          price: "120",
          amount: 2400,
          count: 20,
          checkName: "tc1",
          checkList: ["20≤X<100"],
          check: null,
          link: process.env.VUE_APP_PORTAL_URL + 'longAgent/buy?ip_count=20',
          taocanId: 1,
        },
      ],
      priceTemps: '[{"gte":20,"lt":100,"m_price":120,"q_price":0,"y_price":0},{"gte":100,"lt":500,"m_price":118,"q_price":0,"y_price":0},{"gte":500,"lt":1000,"m_price":115,"q_price":0,"y_price":0},{"gte":1000,"lt":10000,"m_price":110,"q_price":0,"y_price":0}]',
      min: 20,
    };
  },
  mounted() {
    for (let i in this.tcgmList) {
      this.freshPrice(i)
    }
  },
  methods: {
    inputChange(index, attr) {
      let count = parseInt(this.tcgmList[index].count);
      if (isNaN(count) || count < 20) {
        count = 20
      }
      if (attr == "del") {
        if (count <= 20) return;
        this.tcgmList[index].count--;
      } else {
        this.tcgmList[index].count++;
      }

      this.freshPrice(index)
    },
    countChange(e, index) {
      this.tcgmList[index].count = e.target.value.replace(/[^\d]/g, "");
      if (this.tcgmList[index].count !== "") {
        this.tcgmList[index].count = parseInt(this.tcgmList[index].count);
      }
      this.freshPrice(index)
    },
    checkChange(index, cheIndex) {
      this.tcgmList[index].check = cheIndex;
    },
    // 计算价格
    freshPrice(index) {
      // console.dir('1231231231231321321323')

      let temp = JSON.parse(this.priceTemps)
      // console.dir(temp)

      let count = this.tcgmList[index].count

      for (let i in temp) {
        i = Number(i)
        if (i < temp.length - 1) {
          if (count >= temp[i].gte && count < temp[i+1].gte) {
            this.tcgmList[index].checkList = [temp[i].gte + ' ≤ X < ' + temp[i].lt]
            this.tcgmList[index].price = temp[i].m_price
            this.tcgmList[index].amount = (temp[i].m_price * count).toFixed(2)
            break
          }
        } else if (i >= temp.length - 1) {
          if (count >= temp[i].gte) {
            this.tcgmList[index].checkList = [temp[i].gte + ' ≤ X < ' + temp[i].lt]
            this.tcgmList[index].price = temp[i].m_price
            this.tcgmList[index].amount = (temp[i].m_price * count).toFixed(2)
            break
          }
        }
      }

      if ( count < 20 || isNaN(count) ) {
        this.tcgmList[index].checkList = ['最低并发个数为20']
      }


      this.tcgmList[index].link = process.env.VUE_APP_PORTAL_URL + 'longAgent/buy?ip_count=' + count
    },
  },
};
</script>

<style lang="less" scoped>
.tcgm {
  padding: 97px 0 66px;
  .item {
    width: 316px;
    height: 608px;
    border: 3px solid #f78834;
    border-radius: 16px;
    position: relative;
    transition: all 0.3s;
    .title {
      font-size: 24px;
      color: #000;
      font-weight: bold;
      margin: 26px 0 0 30px;
      span {
        font-weight: normal;
        margin-left: 16px;
      }
    }
    .price {
      margin: 20px 0 20px 39px;
      font-size: 40px;
      color: #000;
      font-weight: bold;
      b {
        font-size: 54px;
        font-weight: normal;
      }
    }
    .count {
      margin-left: 39px;
      margin-bottom: 26px;
      .input {
        i {
          background-size: 100% 100%;
          width: 30px;
          height: 24px;
          line-height: 24px;
          display: inline-block;
          vertical-align: middle;
          cursor: pointer;
          &.del {
            margin-right: 1px;
            background: url("../../assets/images/del.png");
          }
          &.add {
            margin-left: 1px;
            background: url("../../assets/images/add.png");
          }
        }
        input {
          width: 88px;
          line-height: 24px;
          height: 24px;
          background: #f78834;
          border: none;
          color: #fff;
          text-align: center;
          outline: none;
        }
      }
    }
    .text1 {
      font-size: 18px;
      color: #000;
      margin-left: 39px;
    }
    dl {
      margin-left: 24px;
      dd {
        margin-bottom: 14px;
        input[type="radio"] {
          appearance: none;
          content: "";
          display: inline-block;
          width: 20px;
          height: 20px;
          margin-right: 10px;
          border: 2px solid #f78834;
          border-radius: 50%;
          vertical-align: middle;
          position: relative;
        }
        input[type="radio"]:checked:before {
          content: "";
          display: inline-block;
          width: 10px;
          height: 10px;
          background-color: #f78834;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          border-radius: 50%;
        }
        label {
          margin: 0;
        }
      }
    }
    a {
      display: inline-block;
      width: 168px;
      line-height: 48px;
      background: #f78834;
      font-size: 20px;
      color: #fff;
      text-align: center;
      border-radius: 10px;
      position: absolute;
      bottom: 46px;
      left: 50%;
      transform: translate(-50%, 0);
    }
    &:hover {
      box-shadow: 0 2px 20px 6px #fddec7;
    }
  }
}
@media (max-width: 1534px) {
  .tcgm {
    padding: 3% 0;
  }
  .tcgm .item {
    width: 24%;
  }
}
@media (max-width: 1480px) {
  .width1394 {
    width: 96%;
  }
  .tcgm .item .title,
  .tcgm .item .price,
  .tcgm .item .count {
    margin: 4% 0 0 6%;
  }
  .tcgm .item .text1 {
    margin-top: 2%;
    margin-left: 6%;
  }
}
@media (max-width: 1200px) {
  .tcgm .item {
    width: 49%;
    height: 600px;
    margin-bottom: 2%;
  }
}
@media (max-width: 768px) {
  .tcgm .item {
    width: 100%;
    height: 560px;
  }
  .tcgm .item .title {
    font-size: 20px;
  }
  .tcgm .item .title span,
  .tcgm .item .text1,
  .count span,
  .tcgm .item dl dd label,
  .tcgm .item a {
    font-size: 16px;
  }
  .tcgm .item .price b {
    font-size: 40px;
  }
  .tcgm .item .price {
    font-size: 30px;
  }
}
</style>
